(function () {
  // Only enable on devices that support hover and fine pointer (desktop/laptop)
  const supportsHover =
    window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  if (!supportsHover) return;

  const POP_ID = "swatch-popover";
  let popover = document.getElementById(POP_ID);
  if (!popover) {
    popover = document.createElement("div");
    popover.id = POP_ID;
    popover.className = "swatch-popover";
    popover.setAttribute("role", "tooltip");
    popover.innerHTML =
      '\n      <div class="swatch-popover__image"></div>\n      <div class="swatch-popover__label"></div>\n    ';
    document.body.appendChild(popover);
  }

  const imgEl = popover.querySelector(".swatch-popover__image");
  const labelEl = popover.querySelector(".swatch-popover__label");
  let visible = false;

  function showPopover(e, imageUrl, labelText) {
    if (!imageUrl) return;
    imgEl.style.backgroundImage = 'url("' + imageUrl + '")';

    // Format label text to ensure proper spacing before parentheses
    let formattedText = labelText || "";
    if (formattedText) {
      // Add space before opening parenthesis if missing
      formattedText = formattedText.replace(/([^\s])\(/g, "$1 (");
    }

    labelEl.textContent = formattedText;
    popover.classList.add("swatch-popover--visible");
    visible = true;
    positionPopover(e);
  }

  function hidePopover() {
    popover.classList.remove("swatch-popover--visible");
    visible = false;
  }

  function cleanCdnUrl(urlStr) {
    if (!urlStr) return urlStr;
    try {
      // Support relative URLs from inline styles
      const a = document.createElement("a");
      a.href = urlStr;
      const u = new URL(a.href, window.location.origin);

      // Remove width parameter to fetch original image
      u.searchParams.delete("width");
      u.searchParams.delete("height");
      u.searchParams.delete("crop");

      // Also handle the legacy _WxH or _Wx format sometimes found in Shopify URLs
      let cleanUrl = u.toString();
      cleanUrl = cleanUrl.replace(
        /_(?:[0-9]+x[0-9]*|[0-9]*x[0-9]+|small|medium|large|grande|compact)\.(jpg|jpeg|png|gif|webp)/gi,
        ".$1"
      );

      return cleanUrl;
    } catch (e) {
      // Fallback: strip `width=...` with regex
      return urlStr
        .replace(/([?&])width=\d+/i, function (m, p1) {
          return p1 === "?" ? "?" : "";
        })
        .replace(/([?&])height=\d+/i, function (m, p1) {
          return p1 === "?" ? "?" : "";
        })
        .replace(/([?&])crop=\w+/i, function (m, p1) {
          return p1 === "?" ? "?" : "";
        })
        .replace(/\?&/, "?")
        .replace(/\?$/, "");
    }
  }

  function extractBgUrl(el) {
    if (!el) return null;
    // Prefer inline style background-image to avoid computed style cross-origin fallbacks
    const bg =
      el.style && el.style.backgroundImage
        ? el.style.backgroundImage
        : getComputedStyle(el).backgroundImage;
    if (!bg || bg === "none") return null;
    const match = bg.match(/url\(["']?(.*?)["']?\)/i);
    const raw = match ? match[1] : null;
    return cleanCdnUrl(raw);
  }

  function positionPopover(e) {
    if (!visible) return;
    const margin = 14; // space from cursor
    const vw = window.innerWidth;
    const vh = window.innerHeight;

    let popRect;
    // Temporarily place to measure size
    popover.style.left = "0px";
    popover.style.top = "0px";
    popRect = popover.getBoundingClientRect();

    let x = e.clientX + margin;
    let y = e.clientY + margin;

    // Keep inside viewport
    if (x + popRect.width + margin > vw) {
      x = e.clientX - popRect.width - margin;
    }
    if (y + popRect.height + margin > vh) {
      y = e.clientY - popRect.height - margin;
    }

    // Apply
    popover.style.transform = "translate(0, 0)";
    popover.style.left = Math.max(8, x) + "px";
    popover.style.top = Math.max(8, y) + "px";
  }

  function handleEnter(e) {
    const link = e.currentTarget;
    const content = link.querySelector(".f-swatch__list__link__content");
    const label = link.querySelector(".f-swatch__label");
    const url = extractBgUrl(content);
    const text = label ? label.textContent.trim() : "";
    if (!url) return;
    showPopover(e, url, text);
  }

  function handleMove(e) {
    if (visible) positionPopover(e);
  }

  function handleLeave() {
    hidePopover();
  }

  function bind() {
    const swatchLinks = document.querySelectorAll(
      ".wt-product__option__body--swatches .f-swatch__list__link"
    );
    if (!swatchLinks.length) return;
    swatchLinks.forEach(function (link) {
      link.addEventListener("mouseenter", handleEnter);
      link.addEventListener("mousemove", handleMove);
      link.addEventListener("mouseleave", handleLeave);
      link.addEventListener("focus", function () {
        // keyboard focus
        // synthesize a point near the center of the element
        const rect = link.getBoundingClientRect();
        const syntheticEvent = {
          clientX: rect.left + rect.width / 2,
          clientY: rect.top + rect.height / 2,
          currentTarget: link,
        };
        handleEnter(syntheticEvent);
      });
      link.addEventListener("blur", handleLeave);
    });

    window.addEventListener(
      "scroll",
      function () {
        if (visible) hidePopover();
      },
      { passive: true }
    );
    window.addEventListener("resize", function () {
      if (visible) hidePopover();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
